import { render, staticRenderFns } from "./ExpandedStoryboard.vue?vue&type=template&id=3e022672&scoped=true&"
import script from "./ExpandedStoryboard.vue?vue&type=script&lang=js&"
export * from "./ExpandedStoryboard.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedStoryboard.vue?vue&type=style&index=0&id=3e022672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e022672",
  null
  
)

export default component.exports